import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const AuditEventTable = ({ events, selectedEventId, onSelectEvent }) => {
  const getActionColor = (action) => {
    const actionLower = action?.toLowerCase() || '';
    switch (actionLower) {
      case "create":
    return "bg-success/10 text-success border-success/20";
      case "delete":
        return "bg-error/10 text-error border-error/20";
      case "distributed":
     return "bg-primary/10 text-primary border-primary/20";
      case "update":
        return "bg-warning/10 text-warning border-warning/20";
      case "sync":
        return "bg-secondary/10 text-secondary border-secondary/20";
      case "approved":
     return "bg-success/10 text-success border-success/20";
  default:
return "bg-muted text-muted-foreground border-border";
    }
  };

  const getActionIcon = (action) => {
    const actionLower = action?.toLowerCase() || '';
    switch (actionLower) {
      case "create":
        return "Plus";
      case "delete":
        return "Trash2";
      case "distributed":
      return "Send";
      case "update":
return "Edit";
      case "sync":
        return "RefreshCw";
case "approved":
        return "CheckCircle2";
      case "read":
     return "Eye";
      default:
        return "FileText";
    }
  };

  const getEntityIcon = (entityType) => {
    const type = entityType?.toLowerCase() || '';
    if (type.includes('employee')) return "Users";
    if (type.includes('tronc')) return "PoundSterling";
    if (type.includes('distribution')) return "PieChart";
    if (type.includes('rule')) return "Settings";
    if (type.includes('transaction')) return "CreditCard";
 if (type.includes('jobrole') || type.includes('job')) return "Briefcase";
 if (type.includes('location')) return "MapPin";
    if (type.includes('tenant')) return "Building2";
    if (type.includes('clock')) return "Clock";
 return "FileText";
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) {
      return "Just now";
    } else if (diffMins < 60) {
 return `${diffMins}m ago`;
    } else if (diffHours < 24) {
  return `${diffHours}h ago`;
    } else if (diffDays < 7) {
      return `${diffDays}d ago`;
    } else {
      return date.toLocaleDateString("en-GB", {
   day: "2-digit",
        month: "short",
 }) + ' ' + date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
        minute: "2-digit",
      });
    }
  };

  const formatFullTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
 year: "numeric",
      hour: "2-digit",
    minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      {/* Desktop Table View */}
      <div className="hidden lg:block overflow-x-auto">
 <table className="w-full">
        <thead className="bg-muted/50">
     <tr>
     <th className="text-left px-4 py-3 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
        Action
       </th>
       <th className="text-left px-4 py-3 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
    Entity
    </th>
   <th className="text-left px-4 py-3 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
  Description
              </th>
  <th className="text-left px-4 py-3 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
         User
       </th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
     Time
         </th>
</tr>
          </thead>
          <tbody className="divide-y divide-border">
 {events?.map((event) => (
      <tr
                key={event?.id}
      onClick={() => onSelectEvent(event)}
     className={`cursor-pointer transition-all hover:bg-muted/30 ${
selectedEventId === event?.id
  ? "bg-primary/5"
              : ""
     }`}
          >
    <td className="px-4 py-3">
  <span
             className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-xs font-medium border ${getActionColor(
         event?.eventType
  )}`}
     >
     <Icon name={getActionIcon(event?.eventType)} size={12} />
    {event?.eventType?.charAt(0).toUpperCase() + event?.eventType?.slice(1)}
        </span>
           </td>
           <td className="px-4 py-3">
  <div className="flex items-center gap-2">
         <div className="w-7 h-7 rounded bg-muted flex items-center justify-center">
 <Icon name={getEntityIcon(event?.eventCategory)} size={14} className="text-muted-foreground" />
    </div>
    <div>
<p className="text-sm font-medium">{event?.eventCategory}</p>
  <p className="text-xs text-muted-foreground truncate max-w-[120px]" title={event?.entityId}>
          {event?.entityId?.substring(0, 8)}...
          </p>
       </div>
  </div>
     </td>
           <td className="px-4 py-3">
     <p className="text-sm text-foreground line-clamp-1 max-w-[200px]" title={event?.description}>
         {event?.description || event?.title}
     </p>
    </td>
     <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <Image
       src={event?.user?.avatar}
      alt={event?.user?.name}
    className="w-6 h-6 rounded-full object-cover"
         />
     <span className="text-sm text-muted-foreground truncate max-w-[100px]">
       {event?.user?.name}
   </span>
      </div>
   </td>
        <td className="px-4 py-3">
   <span className="text-xs text-muted-foreground" title={formatFullTimestamp(event?.timestamp)}>
  {formatTimestamp(event?.timestamp)}
</span>
    </td>
      </tr>
  ))}
          </tbody>
     </table>
      </div>

      {/* Mobile Card View */}
      <div className="lg:hidden divide-y divide-border">
        {events?.map((event) => (
      <div
   key={event?.id}
        onClick={() => onSelectEvent(event)}
            className={`p-4 cursor-pointer transition-all hover:bg-muted/30 ${
         selectedEventId === event?.id
     ? "bg-primary/5 border-l-4 border-l-primary"
     : ""
            }`}
          >
        <div className="flex items-start gap-3">
              {/* Entity Icon */}
         <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center flex-shrink-0">
   <Icon
 name={getEntityIcon(event?.eventCategory)}
      size={20}
 className="text-foreground"
             />
              </div>

           {/* Event Details */}
              <div className="flex-1 min-w-0">
             <div className="flex items-start justify-between gap-2 mb-1">
         <h3 className="text-sm font-semibold text-foreground truncate">
           {event?.title}
</h3>
       <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium border flex-shrink-0 ${getActionColor(
    event?.eventType
         )}`}
      >
      <Icon name={getActionIcon(event?.eventType)} size={10} />
            {event?.eventType}
          </span>
   </div>
                <p className="text-xs text-muted-foreground line-clamp-2 mb-2">
        {event?.description}
         </p>

    {/* User and Timestamp */}
                <div className="flex items-center justify-between">
    <div className="flex items-center gap-2">
<Image
          src={event?.user?.avatar}
    alt={event?.user?.name}
       className="w-5 h-5 rounded-full object-cover"
  />
   <span className="text-xs text-muted-foreground">
       {event?.user?.name}
               </span>
           </div>
  <span className="text-xs text-muted-foreground" title={formatFullTimestamp(event?.timestamp)}>
      {formatTimestamp(event?.timestamp)}
          </span>
  </div>
   </div>
      </div>
          </div>
        ))}
      </div>

    {events?.length === 0 && (
 <div className="p-12 text-center">
          <Icon
name="Search"
            size={48}
            className="text-muted-foreground mx-auto mb-4"
          />
   <p className="text-sm text-muted-foreground">
            No events found matching your filters
          </p>
        </div>
      )}
    </div>
  );
};

export default AuditEventTable;
